import { config } from '../../lib/config';

export interface NotificationDto {
  id: string;
  type: string;
  /** Аккаунт (serviceSubscriptionId) получателя — для переключения подписки при клике. */
  accountId?: string | null;
  mailboxId: string;
  messageId: string;
  from: string;
  subject?: string | null;
  attachmentCount: number;
  createdAt: string;
}

/** История уведомлений (N2) — восстанавливает колокольчик после перезагрузки. */
export async function fetchNotifications(): Promise<NotificationDto[]> {
  const res = await fetch(`${config.apiBase}/api/notifications`, { credentials: 'include' });
  if (res.status === 401) return [];
  if (!res.ok) throw new Error(`notifications ${String(res.status)}`);
  const body = (await res.json()) as { items?: NotificationDto[] };
  return body.items ?? [];
}
